import {
  type ConnectionDto,
  type ConnectionPropsBase,
  type ConnectionType,
} from "@jugl-web/rest-api";

type IntegrationTileState = {
  isConnected: boolean;
  needsSetup: boolean;
  isExpired: boolean;
  connectionId: string | null;
};

export const getIntegrationTileState = (
  connections: ConnectionDto[] | undefined
): IntegrationTileState => {
  const firstConnection = connections?.[0];
  if (!firstConnection) {
    return {
      isConnected: false,
      needsSetup: false,
      isExpired: false,
      connectionId: null,
    };
  }

  const status = (firstConnection.props as ConnectionPropsBase | undefined)
    ?.status;

  if (status === "connected") {
    return {
      isConnected: true,
      needsSetup: false,
      isExpired: false,
      connectionId: firstConnection.id,
    };
  }

  if (status === "expired") {
    return {
      isConnected: true,
      needsSetup: false,
      isExpired: true,
      connectionId: firstConnection.id,
    };
  }

  return {
    isConnected: true,
    needsSetup: true,
    isExpired: false,
    connectionId: firstConnection.id,
  };
};

export const groupConnectionsByType = (
  connections: ConnectionDto[] | undefined
): Partial<Record<ConnectionType, ConnectionDto[]>> =>
  (connections ?? []).reduce(
    (acc, connection) => {
      const group = acc[connection.type] ?? [];
      group.push(connection);
      acc[connection.type] = group;
      return acc;
    },
    {} as Partial<Record<ConnectionType, ConnectionDto[]>>
  );
